<div class="">
  <div class="flex justify-between items-center mb-5">
    <span class="text-2xl font-bold text-inverse-primary">{{
      "OVERVIEW.OVERVIEW" | translate
      }}</span>
    <div *ngIf="showStatusIcon" class="flex items-center">
      <span class="mx-3 text-white text-lg font-semibold">
        {{ getClaimStatusName() | translate }}
      </span>
      <div class="p-4 rounded-lg items-center md:ml-5 ml-0 justify-center" [ngClass]="getCaseStatusIcon()"></div>
    </div>
  </div>
  <hr class="text-white" />
</div>

@if(enableSplitLayout){
<div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
  <div class="min-w-0">
    @for(metric of leftColumnData; track $index){
    @if(metric.label !== 'CASE_DETAIL.INCIDENT_TYPE'){
    <div class="flex items-center w-full mb-6 gap-6">
      <div class="text-wrap w-[140px] shrink-0">
        <span class="text-light font-medium overview-label-with-tooltip">
          {{ metric.label | translate }}:
          @if(metric.tooltip){
          <button
            type="button"
            class="overview-label-tooltip-trigger"
            (click)="infoPopover.toggle($event)"
            aria-label="More info"
          >
            <i class="fa fa-circle-info overview-label-tooltip-icon"></i>
          </button>
          <p-popover #infoPopover [dismissable]="false" [focusOnShow]="false" styleClass="overview-tooltip-popover">
            <span>{{ metric.tooltip | translate }}</span>
          </p-popover>
          }
        </span>
      </div>
      <div class="text-wrap text-left">
        <div class="flex items-center justify-start">
          <span class="text-light font-bold text-lg whitespace-nowrap">
            {{ formatMetricValue(metric) }}
          </span>
          @if(metric.label === 'CASE_DETAIL.CLAIM_SEVERITY'){
          <div class="rounded-full flex items-center justify-center text-white ml-2"
            [ngClass]="getSeverityBadge(metric.data).badgeClass" style="width: 20px; height: 20px">
            <i [class]="getSeverityBadge(metric.data).iconClass" class="text-white text-sm">
            </i>
          </div>
          }
        </div>
      </div>
    </div>
    }
    }

    @if (api.includes('coassess') && showHospitalization) {
    <div class="flex items-center w-full mb-4 gap-6">
      <div class="text-wrap w-[140px] shrink-0">
        <span class="text-light font-medium">
          {{ "OVERVIEW.HOSPITALIZATION_DURATION" | translate }}:
        </span>
      </div>
      <div class="text-wrap text-left">
        <span class="text-light font-bold text-lg whitespace-nowrap">
          {{ this.dateStarted ?? "-"}}@if(dateStarted){ {{ "OVERVIEW.DAYS" | translate }}}
        </span>
      </div>
    </div>
    }
  </div>

  @if(rightColumnData.length > 0){
  <div class="min-w-0">
    @for(metric of rightColumnData; track $index){
    <div class="flex items-center w-full mb-6 gap-6">
      <div class="text-wrap w-[140px] shrink-0">
        <span class="text-light font-medium overview-label-with-tooltip">
          {{ metric.label | translate }}:
          @if(metric.tooltip){
          <button
            type="button"
            class="overview-label-tooltip-trigger"
            (click)="infoPopover.toggle($event)"
            aria-label="More info"
          >
            <i class="fa fa-circle-info overview-label-tooltip-icon"></i>
          </button>
          <p-popover #infoPopover [dismissable]="false" [focusOnShow]="false" styleClass="overview-tooltip-popover">
            <span>{{ metric.tooltip | translate }}</span>
          </p-popover>
          }
        </span>
      </div>
      <div class="text-wrap text-left">
        <div class="flex items-center justify-start">
          <span class="text-light font-bold text-lg whitespace-nowrap">
            {{ formatMetricValue(metric) }}
          </span>
          @if(metric.label === 'CASE_DETAIL.CLAIM_SEVERITY'){
          <div class="rounded-full flex items-center justify-center text-white ml-2"
            [ngClass]="getSeverityBadge(metric.data).badgeClass" style="width: 20px; height: 20px">
            <i [class]="getSeverityBadge(metric.data).iconClass" class="text-white text-sm">
            </i>
          </div>
          }
        </div>
      </div>
    </div>
    }
  </div>
  }
</div>
<hr class="h-[1px] bg-white border-0 my-2" />
@if(incidentTypeMetric){
<div class="mt-2">
  <div class="flex items-center w-full mb-4 gap-6">
    <div class="text-wrap w-[140px] shrink-0">
      <span class="text-light font-medium">
        {{ incidentTypeMetric.label | translate }}:
      </span>
    </div>
    <div class="text-wrap text-left">
      <span class="text-light font-bold text-lg">
        {{ formatMetricValue(incidentTypeMetric) }}
      </span>
    </div>
  </div>

  @if(admissionType){
  <div class="flex items-center w-full mb-4 gap-6">
    <div class="text-wrap w-[140px] shrink-0">
      <span class="text-light font-medium">
        {{ "CASE_DETAIL.ADMISSION_TYPE" | translate }}:
      </span>
    </div>
    <div class="text-wrap text-left">
      <span class="text-light font-bold text-lg">
        {{ admissionType | translate }}
      </span>
    </div>
  </div>
  }

  @if(incidentTypeMetric.data === 'Operational'){
  <!-- <div class="flex items-center w-full mb-2 gap-6">
    <div class="text-wrap w-[140px] shrink-0">
      <span class="text-light font-medium">
        {{ "OVERVIEW.SURGERIES_DESCRIPTION" | translate }}:
      </span>
    </div>
    <div class="text-wrap text-left">
      <span class="text-light font-bold text-lg">
        {{ surgeriesDescription ?? "-" }}
      </span>
    </div>
  </div> -->
   @if(clinic){
  <div class="flex items-center w-full mb-4 gap-6">
    <div class="text-wrap w-[140px] shrink-0">
      <span class="text-light font-medium">
        {{ "OVERVIEW.CLINIC" | translate }}:
      </span>
    </div>
    <div class="text-wrap text-left">
      <span class="text-light font-bold text-lg">{{ clinic }}</span>
    </div>
  </div>
  }
  @if(hospital){
  <div class="flex items-center w-full mb-4 gap-6">
    <div class="text-wrap w-[140px] shrink-0">
      <span class="text-light font-medium">
        {{ "OVERVIEW.HOSPITAL" | translate }}:
      </span>
    </div>
    <div class="text-wrap text-left">
      <span class="text-light font-bold text-lg">{{ hospital }}</span>
    </div>
  </div>
  }
  }

  @if(incidentTypeMetric.data === 'Pathological'){
  @if(tpaDischargeIcd10Code || tpaDischargeIcd10Description){
  <div class="flex items-center w-full mb-4 gap-6">
    <div class="text-wrap w-[140px] shrink-0">
      <span class="text-light font-medium">
        {{ "OVERVIEW.TPA_DISCHARGE_ICD10" | translate }}:
      </span>
    </div>
    <div class="text-wrap text-left">
      <span class="text-light font-bold text-lg">
        {{ tpaDischargeIcd10Code }}@if(tpaDischargeIcd10Code && tpaDischargeIcd10Description){ - }{{ tpaDischargeIcd10Description }}
      </span>
    </div>
  </div>
  }
  @if(clinic){
  <div class="flex items-center w-full mb-4 gap-6">
    <div class="text-wrap w-[140px] shrink-0">
      <span class="text-light font-medium">
        {{ "OVERVIEW.CLINIC" | translate }}:
      </span>
    </div>
    <div class="text-wrap text-left">
      <span class="text-light font-bold text-lg">{{ clinic }}</span>
    </div>
  </div>
  }
  @if(hospital){
  <div class="flex items-center w-full mb-4 gap-6">
    <div class="text-wrap w-[140px] shrink-0">
      <span class="text-light font-medium">
        {{ "OVERVIEW.HOSPITAL" | translate }}:
      </span>
    </div>
    <div class="text-wrap text-left">
      <span class="text-light font-bold text-lg">{{ hospital }}</span>
    </div>
  </div>
  }
  }
</div>
}
} @else {
<div class="mt-4">
  @for(metric of data; track $index){
  <div class="flex items-center w-full mb-4 gap-6">
    <div class="text-wrap w-[140px] shrink-0">
      <span class="text-light font-medium overview-label-with-tooltip">
        {{ metric.label | translate }}:
        @if(metric.tooltip){
        <button
          type="button"
          class="overview-label-tooltip-trigger"
          (click)="infoPopover.toggle($event)"
          aria-label="More info"
        >
          <i class="fa fa-circle-info overview-label-tooltip-icon"></i>
        </button>
        <p-popover #infoPopover [dismissable]="false" [focusOnShow]="false" styleClass="overview-tooltip-popover">
          <span>{{ metric.tooltip | translate }}</span>
        </p-popover>
        }
      </span>
    </div>
    <div class="text-wrap text-left">
      <div class="flex items-center justify-start">
        <span class="text-light font-bold text-lg whitespace-nowrap">
          {{ formatMetricValue(metric) }}
        </span>
        @if(metric.label === 'CASE_DETAIL.CLAIM_SEVERITY'){
        <div class="rounded-full flex items-center justify-center text-white ml-2"
          [ngClass]="getSeverityBadge(metric.data).badgeClass" style="width: 20px; height: 20px">
          <i [class]="getSeverityBadge(metric.data).iconClass" class="text-white text-sm">
          </i>
        </div>
        }
      </div>
    </div>
  </div>
  }
</div>
}
